import generateNumberArray from '../utils/generateNumberArray';

const useResonanceAgeOptions = () => {
  const agesArr = generateNumberArray(15, 89, 1);
  const formattedRespondentVolumes = agesArr.map((age) => ({ label: String(age), value: String(age) }));

  return [...formattedRespondentVolumes, { label: '90+', value: '90+' }];
};

export default useResonanceAgeOptions;
